import { createSlice } from "@reduxjs/toolkit";

export const initialState = 
{
  visibleActualsTreatments: [],
}

export const actualsTreatmentsSlice = createSlice({
  name: 'actualsTreatments',
  initialState,
  reducers: {
    setActualsTreatments: (state, action) => {
      state.visibleActualsTreatments = action.payload;
    }
  }
});

export const {setActualsTreatments} = actualsTreatmentsSlice.actions;

export default actualsTreatmentsSlice.reducer;